import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Deviousness from './DeviousnessBox';
import DeviousnessV2 from '../../UserWidgets.deviation_gruser/Deviousness/DeviousnessBox';

export default withFeatureBranch({ deviation_gruser: DeviousnessV2 })(
  Deviousness
);
